import { useNavigate } from 'react-router-dom';
import { clearOutbox } from '../lib/offline/outbox.js';
import { clearSavedQueries } from '../lib/offline/persist.js';
import { useQueryClient } from '@tanstack/react-query';
import { theme } from '../theme.js';
import { signOut } from '../lib/auth.js';
import { useAuth } from '../context/AuthContext.js';
import { Button } from '../components/Button.js';

/** Signed in, but not a member of any unit (removed, or never joined). */
export function NoAccessPage() {
  const nav = useNavigate();
  const qc = useQueryClient();
  const { refresh, user } = useAuth();

  async function handleSignOut() {
    await signOut();
    await Promise.all([clearOutbox(), clearSavedQueries()]); // nothing of theirs for the next sign-in
    qc.clear();
    await refresh();
    nav('/login', { replace: true });
  }

  return (
    <div style={{
      minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: theme.bg, padding: 24, fontFamily: theme.font,
    }}>
      <div style={{ width: '100%', maxWidth: 360, textAlign: 'center' }}>
        <div style={{ fontSize: 22, fontWeight: 700, color: theme.text, marginBottom: 8 }}>Not in a unit</div>
        <div style={{ fontSize: 14, color: theme.textDim, lineHeight: 1.5, marginBottom: 20 }}>
          {user?.email ?? 'This account'} isn't a member of any unit. Ask your unit's admin for an invite.
        </div>
        <Button fullWidth variant="secondary" onClick={handleSignOut}>Sign out</Button>
      </div>
    </div>
  );
}
